//import Icon from '@mui/material/Icon';

// Example
// const routes = [
//   {
//     name: 'Dashboard',
//     icon: <Icon>dashboard</Icon>,
//   },
// ];
const routes = [];

export default routes;
